import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 20,
        marginBottom: 3
    },
    billTo: {
        color: '#000',
        fontSize: 14,
    },
  });


  const AgentTo = ({invoice}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Reservation Agent Details</Text>
    </View>
  );
  
  export default AgentTo